import React from 'react';
import '../css/About.css';

const About = () => {
  return (
    <React.Fragment>
      <div className="about">
        <h2>Hi! I'm <span id="red">Rinat Tregerman, </span>a</h2>
        <h2>Creative Technologist, ex-LinkedIn. </h2>
        <p>Driven to create rich and seamless interactive experiences.</p>
      </div>
    </React.Fragment>
  )
}

export default About;
